export enum EBlockingMode {
  WAIT_FOR_PREFETCH_SEGMENT = 'waitForSegment',
  WAIT_FOR_PLAYLIST = 'waitForPlaylist',
}
